<template>
  <div>
    <SimplingDetails
      v-show="step === 0"
      @nextStep="nextStep"
      @prevStep="prevStep"
    ></SimplingDetails>
    <Review
      v-if="step === 1"
      @nextStep="nextStep"
      @prevStep="prevStep"
    ></Review>
    <Instructions
      v-if="step === 2"
      @nextStep="nextStep"
      @prevStep="prevStep"
    ></Instructions>
    <ShareReport
      v-if="step === 3"
      @nextStep="nextStep"
      @prevStep="prevStep"
    ></ShareReport>
  </div>
</template>

<script>
import SimplingDetails from "../KitActivation/SimplingDetails";
import Review from "../KitActivation/Review";
import Instructions from "../KitActivation/Instructions";
import ShareReport from "../KitActivation/ShareReport";

export default {
  name: "LoggedInV2Activation",
  props: ["initialStep"],
  data() {
    return {
      step: this.initialStep || 0
    };
  },
  components: {
    SimplingDetails,
    Review,
    Instructions,
    ShareReport
  },
  methods: {
    nextStep(e) {
      const next = this.step + e;
      if (next > 3) {
        this.$emit("reRenderHome");
        if (this.$route.path !== "/home") {
          this.$router.push("/home");
        }
        return;
      }
      this.step = next;
    },
    prevStep(e) {
      this.step -= e;
    },
    reRenderHome() {
      this.$emit("reRenderHome");
    }
  }
};
</script>
